import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from './profile.service';
import { CookieService } from 'src/app/core/services/cookie.service';
import { environment } from 'src/environments/environment';
import { CurrentUser } from 'src/app/core/models/CurrentUser';
import { Helpers } from '../../../helpers';
import { UserService } from './user.service';
import { AccountService } from './account.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    urlToken: any;
    userValid: Boolean = false;

    constructor(private appService: AppService,
        private toastr: ToastrService,
        private route: Router,
        private profileService: ProfileService,
        private cookieService: CookieService,
        private userService: UserService,
        private accountService: AccountService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.isLogged()) {
            return true;
        } else {
            window.location.href = environment.endpointSSO.url;
            return false;
        }
    }

    isLogged() : Boolean {
        // Pega url ativa e extrai o token
        this.urlToken = this.appService.getQueryStrings(undefined);

        //Verifica se o usuario é nulo
        if (this.appService.currentUser == null)
            this.appService.currentUser = new CurrentUser();

        //Verifica se o token existe
        if (this.urlToken.accesstoken != undefined)
            this.appService.currentUser.accessToken = this.urlToken.accesstoken;
        //Caso o token não exista
        else if (this.appService.currentUser.accessToken == undefined) {
          return false;
        }
        //Caso token exista seta os cockies
        if (this.appService.currentUser.accessToken != undefined) {

            //Abrir o Token, pegar o campo 'exp' que é o tempo de expiração do token. Aplicar ele nos cookies;
            var token = Helpers.parseJwt(JSON.stringify(this.appService.currentUser.accessToken));
            var exp = new Date(token.exp*1000);

            if(exp < new Date())
                return false;

            //Seta o auth
            this.cookieService.setCookie('auth', JSON.stringify(this.appService.currentUser.accessToken), exp.toUTCString());

            // Reseta isAdminConexia imediatamente (síncrono) para evitar que um cookie
            // de sessão anterior permaneça válido até a chamada async concluir
            this.appService.currentUser.isAdminConexia = false;
            this.cookieService.setCookie('isAdminConexia', JSON.stringify(false), exp.toUTCString());

            this.userService.getUserInfo().subscribe(({ id, name, role }) => {
              //Seta o userId
              this.cookieService.setCookie('userId', JSON.stringify(id), exp.toUTCString());
              this.appService.currentUser.userId = id;
              this.userService.accountId = token.AccountId

              //Seta o userName
              this.cookieService.setCookie('userName', JSON.stringify(name), exp.toUTCString());
              this.appService.currentUser.name = name;

              //Seta a role
              this.cookieService.setCookie('role', JSON.stringify(role), exp.toUTCString());
              this.appService.currentUser.role = role;

              //Verifica se é Admin Conexia pelo tenantId do usuário (guid vazio = Admin Conexia)
              this.accountService.getUserInformations(id).subscribe((user: any) => {
                const isAdminConexia = Helpers.isAdminConexiaV2(user.tenantId, role);
                this.appService.currentUser.isAdminConexia = isAdminConexia;
                this.cookieService.setCookie('isAdminConexia', JSON.stringify(isAdminConexia), exp.toUTCString());
              });
            })

            return true;
        }
    }
}
